var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 377.12 205.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#969ea8;}.cls-3{opacity:0.71;}.cls-4{fill:#4c2457;}.cls-5{fill:#a7acb4;}.cls-6{fill:#d885ae;}.cls-7{opacity:0.89;}.cls-8{fill:#fff;}.cls-9{fill:url(#linear-gradient);}.cls-10{fill:url(#linear-gradient-2);}.cls-11,.cls-13,.cls-15,.cls-19,.cls-22,.cls-24{mix-blend-mode:multiply;}.cls-11,.cls-19{opacity:0.3;}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13,.cls-22{opacity:0.45;}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15,.cls-24{opacity:0.25;}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-12);}.cls-19{fill:url(#linear-gradient-13);}.cls-20{fill:url(#linear-gradient-14);}.cls-21{fill:url(#linear-gradient-15);}.cls-22{fill:url(#linear-gradient-16);}.cls-23{fill:url(#linear-gradient-17);}.cls-24{fill:url(#linear-gradient-18);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 242.56,
    y1: 39.4,
    x2: 168.82,
    y2: -2.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b56eac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 137.38,
    y1: 27.44,
    x2: 188.56,
    y2: 27.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e492a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7866ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6c60a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4d50a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e499e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 173.94,
    y1: 13.98,
    x2: 188.56,
    y2: 13.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 144.69,
    y1: 36.34,
    x2: 144.69,
    y2: 67.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 144.69,
    y1: 37.44,
    x2: 144.69,
    y2: 47.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 152,
    y1: 70.02,
    x2: 218.43,
    y2: 70.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 144.98,
    y1: 52.19,
    x2: 157.1,
    y2: 57.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1086.33,
    y1: 326.36,
    x2: 1012.58,
    y2: 284.35,
    gradientTransform: "translate(1220.89 405.87) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 981.15,
    y1: 314.39,
    x2: 1032.33,
    y2: 314.39,
    gradientTransform: "translate(1220.89 405.87) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 981.15,
    y1: 314.39,
    x2: 1032.33,
    y2: 314.39,
    gradientTransform: "translate(1220.89 405.87) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1017.71,
    y1: 300.93,
    x2: 1032.33,
    y2: 300.93,
    gradientTransform: "translate(1220.89 405.87) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 988.46,
    y1: 323.3,
    x2: 988.46,
    y2: 354.29,
    gradientTransform: "translate(1220.89 405.87) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 988.46,
    y1: 323.3,
    x2: 988.46,
    y2: 354.29,
    gradientTransform: "translate(1220.89 405.87) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 988.46,
    y1: 324.4,
    x2: 988.46,
    y2: 334.73,
    gradientTransform: "translate(1220.89 405.87) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 995.77,
    y1: 356.97,
    x2: 1062.2,
    y2: 356.97,
    gradientTransform: "translate(1220.89 405.87) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 988.75,
    y1: 339.15,
    x2: 1000.86,
    y2: 344.31,
    gradientTransform: "translate(1220.89 405.87) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M911.94,564.3c-29.77-10-63,6.32-91.63-7.92a3.47,3.47,0,0,0-2.19-.56,3.81,3.81,0,0,0-1.61,1l-30.24,27.68c6.47-.95,27.68.18,33.5.52q17,1,33.86,3.43a408.86,408.86,0,0,1,67.21,15.63c12.4,4,24.49,9.88,36.86,13.72C950.8,592,932.85,571.33,911.94,564.3Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M921.63,565.69C905,557,886.59,555,868.54,554.57c-12.28-.33-25.6-.42-35.28-9.88a35.19,35.19,0,0,0,13.13-4.77c1.72,3.57,5.05,5.33,8.24,6.51,15.68,5.79,32.57,3,48.66,6.55,20.92,4.67,40.06,20.73,51.47,43.18a52,52,0,0,1,5.07,15.34c-3.08-9.1-10.05-20.39-13.53-25A73.69,73.69,0,0,0,921.63,565.69Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M909.4,546.53c-8-2.14-16.71-2.35-24.83-3.48a46,46,0,0,1-11.69-2.82,22.14,22.14,0,0,1-9.92-8,16,16,0,0,0,9.65-1.79,8.79,8.79,0,0,0,2.56,4.45,22.26,22.26,0,0,0,11.22,5.91c4,.92,8.15,1.1,12.23,1.58,10.65,1.25,21.46,4.83,30.42,12.38a88.12,88.12,0,0,1,9.84,10.44C930,555.63,919.14,549.14,909.4,546.53Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M959.83,626.77s-71.09-34.3-178.52-34.68l-10,9.15S861.12,590.57,959.83,626.77Z",
    transform: "translate(-771.27 -437.34)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1007.88,564.73c29.65-10,62.72,6.3,91.26-7.88a3.46,3.46,0,0,1,2.19-.56,3.82,3.82,0,0,1,1.6,1L1133,584.9c-6.44-.94-27.57.18-33.36.52q-16.9,1-33.72,3.41a406.76,406.76,0,0,0-67,15.58c-12.34,4-24.39,9.84-36.71,13.66C969.18,592.33,987.06,571.74,1007.88,564.73Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M998.22,566.12c16.61-8.63,34.91-10.6,52.89-11.08,12.22-.32,25.5-.42,35.14-9.84a35,35,0,0,1-13.09-4.75c-1.7,3.56-5,5.31-8.2,6.48-15.62,5.77-32.44,3-48.47,6.53-20.84,4.65-39.9,20.64-51.26,43a51.87,51.87,0,0,0-5.05,15.27c3.06-9.06,10-20.3,13.48-24.86A73.29,73.29,0,0,1,998.22,566.12Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1010.26,546.75c8-2.14,16.71-2.35,24.83-3.48a46,46,0,0,0,11.7-2.82,22.06,22.06,0,0,0,9.91-8,16,16,0,0,1-9.65-1.79,8.79,8.79,0,0,1-2.56,4.45,22.18,22.18,0,0,1-11.22,5.91c-4,.92-8.14,1.1-12.22,1.58-10.66,1.25-21.46,4.83-30.42,12.39a86.54,86.54,0,0,0-9.85,10.43C989.69,555.85,1000.52,549.36,1010.26,546.75Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M959.83,627s71.1-34.3,178.52-34.68l10,9.15S1058.55,590.79,959.83,627Z",
    transform: "translate(-771.27 -437.34)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M821.69,606.79S898.9,609,959.83,632.42v10.91S927.11,622.06,821.69,606.79Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1098,606.79s-77.21,2.18-138.14,25.63v10.91S992.56,622.06,1098,606.79Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M959.83,437.34l-51.18,29.55v25.33l40.06,23.13,14.62-8.44-40.06-23.13v-8.45l21.94-12.66h0l14.62-8.44L1011,483.78V466.89Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "188.56 0 239.74 29.55 239.74 46.43 173.94 8.44 188.56 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "173.94 8.44 188.56 16.88 137.38 46.43 137.38 29.55 173.94 8.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "173.94 8.44 188.56 16.88 137.38 46.43 137.38 29.55 173.94 8.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "184.01 19.51 188.56 16.88 173.94 8.44 173.94 8.44 184.01 19.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "152 37.99 152 63.32 137.38 54.88 137.38 46.43 152 37.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "152 37.99 152 63.32 137.38 54.88 137.38 46.43 152 37.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "137.38 46.43 137.38 46.43 152 42.66 152 37.99 137.38 46.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "152 46.44 218.44 84.79 203.18 93.59 152 63.32 152 46.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "152 46.44 152 46.44 152 63.32 156.04 65.65 152 46.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M959.83,556.25,1011,526.7V501.37L971,478.25l-14.62,8.44,40.06,23.13v8.44l-21.94,12.67h0l-14.62,8.44-51.18-29.55V526.7Z",
    transform: "translate(-771.27 -437.34)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "188.56 118.91 137.38 89.36 137.38 72.48 203.18 110.47 188.56 118.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "203.18 110.47 188.56 102.03 239.74 72.48 239.74 89.36 203.18 110.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "203.18 110.47 188.56 102.03 239.74 72.48 239.74 89.36 203.18 110.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "193.11 99.4 188.56 102.03 203.18 110.47 203.18 110.47 193.11 99.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "225.12 80.92 225.12 55.59 239.74 64.03 239.74 72.48 225.12 80.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "225.12 80.92 225.12 55.59 239.74 64.03 239.74 72.48 225.12 80.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "239.74 72.48 239.74 72.48 225.12 76.25 225.12 80.92 239.74 72.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "225.12 72.47 158.69 34.12 173.94 25.31 225.12 55.59 225.12 72.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "225.12 72.47 225.12 72.47 225.12 55.59 221.08 53.26 225.12 72.47"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fa39f261bcb60149f27864ebc9fff5bc.svg";
export { ForwardRef as ReactComponent };